import React from 'react';
import {
    Button,
    Tooltip,
    IconButton,
    Toolbar,
    Typography,
    Box,
    TextField,
    InputAdornment,
    Menu,
    MenuItem,
    Checkbox,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    CircularProgress,
    InputLabel,
    FormControl,
    Select,
    Paper,
    RadioGroup, Radio, Autocomplete
} from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import CircleIcon from '@mui/icons-material/Circle';
import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';
// import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Title from '../title/title';
import rejectSvg from '../../assets/images/rejectSvg.svg';
import completedSvg from '../../assets/images/completedSvg.svg';
import FilterWrapper from '../../sharedcomponents/multiselectFilter/filterWrapper';
import ExportExcelIcon from '../../sharedcomponents/customIcons/exportExcelIcon';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LoadingButton from '@mui/lab/LoadingButton';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { makeStyles } from '@mui/styles';
import { ChromePicker } from 'react-color';
import ColorizeIcon from '@mui/icons-material/Colorize';
import FormControlLabel from '@mui/material/FormControlLabel';
import EditOffOutlinedIcon from '@mui/icons-material/EditOffOutlined';
import FilterIcon from '@mui/icons-material/Filter';
import {
    FULL_PERMISSION,
    NO_ACCESS_PERMISSION,
} from '../../constants/Constant';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
// import IOSSwitch from '../../sharedcomponents/switchComponent/IOSSwitch';
import { isEmpty } from 'lodash-es';
import Helper from '../../utility/helper';
import AppConstants from '../../constants/appConstants';
import CircularProgressWithLabel from '../crcularProgressWithLabel';
// import AppConstants from '../../constants/appConstants';
// import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
// import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import UnpublishedOutlinedIcon from '@mui/icons-material/UnpublishedOutlined';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import IOSNameSwitch from '../switchComponent/IOSNameSwitch';
import ArchiveIcon from '@mui/icons-material/Archive';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import WaitListCount from './waitlistCount';
import AllotedUsedCount from './allotedUsedCount';
import CompPurchaseCount from './compPurchaseCount';
import CredentialAllotedUsedCount from './credentialAllotedUsedCount';

const StyledMenu = styled((props) => (

    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));
const Input = styled('input')({
    display: 'none',
});
const useStyles = makeStyles((theme) => ({
    actionIcon: {
        width: 20,
    },
    hotelStyle: {
        display: 'flex',
        flexDirection: 'column',
        width: '70%',
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    }
}));

const EnhancedTableToolbar = (props) => {
    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectAll, setSelectAll] = React.useState(false);
    let eventRole = '';
    if (!isEmpty(eventInfo)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSelectAll = (event) => {
        setSelectAll(!selectAll);
        props.onCheckSelectAll(event);
    };

    const renderHotelAgentRequest = () => {
        return (
            <> {
                (props.endUserView && props.showAgentRoomInfo
                    && props.eventConfigStatus && props.eventConfigStatus.paid > 0) ?
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 2 }}>
                        <Box><Typography variant="subtitle2" color={'primary'} component={'span'}>{AppConstants.HOTEL_AGENT_ROOM_CONFIRM_TEXT}</Typography></Box>
                        <Box sx={{ marginLeft: 2 }}>
                            <FormControl variant="standard">
                                <RadioGroup aria-label="position" name="position"
                                    value={props.isAgentRequestAccepted != null && props.isAgentRequestAccepted !== '' ?
                                        props.isAgentRequestAccepted == 1 ? 'Yes' : 'No' : ''}
                                    onChange={(e) => {
                                        //console.log('checked', e.target.value)
                                        props.handleAgentRoomConfirmation(e.target.value == 'Yes' ? true : false)
                                    }} row >

                                    <FormControlLabel value={'Yes'}
                                        control={<Radio color="primary" size="small" />}
                                        label="Yes" />

                                    <FormControlLabel value={'No'}
                                        control={<Radio color="primary" size="small" />}
                                        label="No" />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Box>
                    : null
            }
            </>
        )
    }
    return (
        <>
            <Box style={{ width: '100%' }}>
                <Toolbar
                    sx={{
                        paddingLeft: '0px !important',
                        paddingRight: '0px !important',
                        bgcolor: '#fff',
                        height: !props.endUserView ? '0' : '-0.5',
                        minHeight: '48px !important',
                        pb: 1,
                        flexWrap: 'wrap',
                    }}>
                    <Typography
                        sx={{ flex: '1 1 100%' }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                margin: '16px',
                            }}>
                            {props.title != undefined &&
                                props.title.length > 0 ? (
                                <Box sx={{ pr: 1.5 }}>
                                    <Title title={props.title} />
                                </Box>
                            ) : null}
                            {props.showFilter ? (
                                <FilterWrapper
                                    data={props.filters}
                                    filterData={props.handleFilterChange}
                                />
                            ) : null}
                            {props.showSelectAll ? (
                                <Checkbox
                                    inputProps={{
                                        'aria-label': 'AllParticipant',
                                    }}
                                    checked={selectAll}
                                    onChange={(event) =>
                                        handleSelectAll(event)
                                    }
                                    // color="secondary"
                                    disabled={false}
                                    sx={{ marginLeft: 2 }}
                                />
                            ) : null}
                            {props.showSearch ? (
                                <TextField
                                    id="search"
                                    size="small"
                                    label={props.searchLabel}
                                    value={props.search}
                                    onChange={props.handleSearchChange}
                                    autoComplete="off"
                                    InputProps={{
                                        endAdornment: (
                                            <>
                                                <InputAdornment position="end">
                                                    <SearchIcon />
                                                </InputAdornment>
                                                <InputAdornment position="end">
                                                    {props.showClearSearch && (
                                                        <IconButton
                                                            onClick={
                                                                props.handleClearSearchChange
                                                            }>
                                                            <CloseOutlinedIcon />
                                                        </IconButton>
                                                    )}
                                                </InputAdornment>
                                            </>
                                        ),
                                    }}
                                    sx={{
                                        mt: 1,
                                        mb: 1,
                                        mr: 1,
                                        ml: 0,
                                        maxWidth: { xs: '100%', md: '90%' },
                                    }}
                                />
                            ) : null}
                            {props.adminSchedulePage && props.filterDates ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        width: '180px',
                                        mr: 1
                                    }}>
                                    <Autocomplete
                                        fullWidth
                                        id="size-small-standard-multi"
                                        size="small"
                                        multiple
                                        options={props.filterDates ? props.filterDates : []}
                                        getOptionLabel={(option) => option}
                                        value={props.gridFilters.date ? props.gridFilters.date : []}
                                        onChange={(e, newValue) => {
                                            props.setGridFilters({
                                                ...props.gridFilters,
                                                date: newValue
                                            });
                                        }}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Activity Date"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Box>
                            ) : null}
                            {props.publishlist ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        width: '150px',
                                    }}>
                                    <FormControl
                                        sx={{ width: '100%' }}
                                        size="small">
                                        <InputLabel id="order-by-select-label">
                                            {props.adminSchedulePage ? 'Filter By' : 'Order By'}
                                        </InputLabel>
                                        <Select
                                            sx={{
                                                width: '100%',
                                            }}
                                            labelId="order-by-select-label"
                                            id="order-by-select"
                                            label={props.adminSchedulePage ? 'Filter By' : 'Order By'}
                                            value={props.publishlistvalue}
                                            onChange={(event) => {
                                                props.handlepublishlistdata(
                                                    event.target.value
                                                );
                                            }}>
                                            {props.publishlistdata.map(
                                                (option) => (
                                                    <MenuItem
                                                        key={option.key}
                                                        value={option.value}
                                                        style={{
                                                            padding:
                                                                '2.5px 4px 2.5px 8px',
                                                        }}>
                                                        <span>
                                                            {option.value}
                                                        </span>
                                                    </MenuItem>
                                                )
                                            )}
                                        </Select>
                                    </FormControl>
                                </Box>
                            ) : null}
                            {props.adminSchedulePage ?
                                <Button
                                    size="small"
                                    variant="contained"
                                    style={{
                                        backgroundColor:
                                            props.primaryColor,
                                        marginLeft: 8,
                                        padding: 8
                                    }}
                                    onClick={() => {
                                        props.resetGridFilters();
                                    }}
                                >
                                    Reset
                                </Button>
                                : null
                            }
                            {props.showSelectedUser ? (
                                <div style={{ flexDirection: 'column', marginLeft: 8 }}>
                                    <Typography
                                        variant="h4"
                                        flexGrow={1}
                                        fontSize={14}
                                        fontWeight={600}>
                                        {props.showSelectedUser}
                                    </Typography>
                                </div>
                            ) : null}
                            {props.showSorting ? (
                                <FormControl fullWidth={false} size="small">
                                    <InputLabel id="order-by-select-label">
                                        Order By
                                    </InputLabel>
                                    <Select
                                        labelId="order-by-select-label"
                                        id="order-by-select"
                                        value={props.sortorder}
                                        label="Order By"
                                        onChange={(event) =>
                                            props.changeSort(
                                                event.target.value
                                            )
                                        }>
                                        <MenuItem key={1} value={1}>
                                            User
                                        </MenuItem>
                                        <MenuItem key={2} value={2}>
                                            Created Date
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            ) : null}
                        </Box>

                        {props.showTiketCount && (
                            <Paper
                                sx={{
                                    width: 200,
                                    p: 2,
                                    borderRadius: '5px',
                                    marginRight: 'auto',
                                    backgroundColor: '#E4EDFF',
                                    margin: '10px 0px 0px 10px',
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        flexDirection: 'row',
                                        gap: '16px',
                                    }}>
                                    <Box>
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: '15px',
                                                color: '#000000',
                                                lineHeight: '32px',
                                                color: '#000000',
                                            }}>
                                            Arrival :{' '}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: '15px',
                                                color: '#000000',
                                                lineHeight: '32px',
                                                color: '#000000',
                                            }}>
                                            Departure :{' '}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                lineHeight: '32px',
                                            }}>
                                            <span
                                                style={{ fontWeight: 900 }}>
                                                {`${props.arrivalUsedCount}`}{' '}
                                            </span>
                                            of{' '}
                                            <span
                                                style={{
                                                    fontWeight: 400,
                                                }}>
                                                {
                                                    props
                                                        .transportTotalCount
                                                        .arrival
                                                }
                                            </span>
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                lineHeight: '32px',
                                            }}>
                                            <span
                                                style={{ fontWeight: 900 }}>
                                                {`${props.departureUsedCount}`}{' '}
                                            </span>
                                            of{' '}
                                            <span
                                                style={{ fontWeight: 400 }}>
                                                {
                                                    props
                                                        .transportTotalCount
                                                        .departure
                                                }
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        )}
                        {/* {props.totalTickets ? (
                            <Paper
                                elevation={3}
                                sx={{
                                    m: '10px 0px 0px 10px',
                                    width: { xs: '100%', md: 530, lg: 530 },
                                    borderRadius: '5px',
                                    p: 2,
                                    marginRight: 'auto',
                                    backgroundColor: '#C4D6FA',
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        flexDirection: 'row',
                                        gap: '16px',
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            justifyContent: 'flex-start',
                                            flexDirection: 'column',
                                        }}>
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: '15px',
                                                    color: '#000000',
                                                    lineHeight: '32px',
                                                    color: '#000000',
                                                }}>
                                                Business:
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: '15px',
                                                    color: '#000000',
                                                    lineHeight: '32px',
                                                    color: '#000000',
                                                }}>
                                                Economy:
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            flexDirection: 'row',
                                            gap: '10px',
                                        }}>
                                        <Box
                                            sx={{
                                                fontSize: '14px',
                                                lineHeight: '32px',
                                            }}>
                                            <span>
                                                {`Allotted :${props.allocatedBusiness !==
                                                    undefined
                                                    ? props.allocatedBusiness
                                                    : 0
                                                    }`}
                                            </span>
                                            <span
                                                style={{
                                                    marginLeft: '5px',
                                                }}>
                                                {`Remaining: ${isNaN(
                                                    props.remainingArrivalBusiness
                                                )
                                                    ? 0
                                                    : props.remainingArrivalBusiness
                                                    } (Arrival) | ${isNaN(
                                                        props.remainingDepartureBusiness
                                                    )
                                                        ? 0
                                                        : props.remainingDepartureBusiness
                                                    } (Departure)`}
                                            </span>
                                        </Box>
                                        <Box
                                            sx={{
                                                fontSize: '14px',
                                                lineHeight: '32px',
                                            }}>
                                            <span>
                                                {`Allotted : ${props.allocatedEconomy !==
                                                    undefined
                                                    ? props.allocatedEconomy
                                                    : 0
                                                    }`}
                                            </span>
                                            <span
                                                style={{
                                                    marginLeft: '5px',
                                                }}>
                                                {`Remaining : ${isNaN(
                                                    props.remainingArrivalEconomy
                                                )
                                                    ? 0
                                                    : props.remainingArrivalEconomy
                                                    } (Arrival) | ${isNaN(
                                                        props.remainingDepartureEconomy
                                                    )
                                                        ? 0
                                                        : props.remainingDepartureEconomy
                                                    } (Departure)`}
                                            </span>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        ) : null} */}
                        {/* {props.usedTickets ? (
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            Used Tickets : {props.usedTickets}
                        </Typography>
                    ) : null}  
                      {props.totalTickets ? (
                        <div style={{ flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                Remaining Tickets
                            </Typography>
                            {props.allocatedBusiness !== 0 && (
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}>
                                    {`Business : ${props.remainingArrivalBusiness} (Arrival) | ${props.remainingDepartureBusiness} (Departure)`}
                                </Typography>
                            )}
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {`Economy : ${props.remainingArrivalEconomy} (Arrival) | ${props.remainingDepartureEconomy} (Departure)`}
                            </Typography>
                        </div>
                    ) : null}   */}

                        {/* {props.eventConfigStatus ? (
                        // <Typography
                        //     variant="h4"
                        //     flexGrow={1}
                        //     fontSize={14}
                        //     fontWeight={400}>
                        //     Complimentary :{props.eventConfigStatus.comp}
                        // </Typography>
                        <div style={{ flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                Alloted
                            </Typography>

                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {`Complimentary : ${props.eventConfigStatus.comp} `}
                            </Typography>

                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {`For Purchase : ${props.eventConfigStatus.paid} `}
                            </Typography>
                        </div>
                    ) : null}
                    {props.eventConfigStatus ? (
                        <div style={{ flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                Remaining
                            </Typography>

                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {`Complimentary : ${props.eventConfigStatus.comp -
                                    props.compUsed
                                    } `}
                            </Typography>

                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {`For Purchase : ${props.eventConfigStatus.paid -
                                    props.purchaseUsed
                                    } `}
                            </Typography>
                        </div>
                    ) : null} */}

                        {props.modPermission &&
                            props.modPermission != NO_ACCESS_PERMISSION ? (
                            <Box
                                component="div"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                {props.showStatus ? (
                                    <>
                                        <Box
                                            component="span"
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}>
                                            <CircleIcon
                                                fontSize="small"
                                                style={{ color: '#F9B811' }}
                                            />
                                            <span
                                                style={{
                                                    fontSize: '14px',
                                                    paddingLeft: '4px',
                                                }}>
                                                Submitted
                                            </span>
                                        </Box>
                                        <Box
                                            component="span"
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}>
                                            <CircleIcon
                                                fontSize="small"
                                                style={{ color: '#169D3C' }}
                                            />
                                            <span
                                                style={{
                                                    fontSize: '14px',
                                                    paddingLeft: '4px',
                                                }}>
                                                Approved
                                            </span>
                                        </Box>
                                    </>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showSlectUnpublished == true ? (
                                    <FormControlLabel
                                        label="Include Unpublish"
                                        control={
                                            <Checkbox
                                                inputProps={{
                                                    'aria-label':
                                                        'Include Unpublished',
                                                }}
                                                checked={
                                                    props.selectUnPublished
                                                }
                                                onChange={(event) =>
                                                    props.handleShowUnpublished(
                                                        event
                                                    )
                                                }
                                                color="primary"
                                                label="Child 1"
                                                sx={{ marginLeft: 2 }}
                                            />
                                        }
                                    />
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showSend == true ? (
                                    <>
                                        {props.individualScheudleEmailLoader ? (
                                            <IconButton title="Send Schedule">
                                                <CircularProgress
                                                    size={20}
                                                />
                                            </IconButton>
                                        ) : (<Tooltip title="Send Schedule">
                                            <IconButton
                                                onClick={
                                                    props.sendIndividualScheduleEmail
                                                }>
                                                <AttachEmailIcon
                                                    color="primary"
                                                    fontSize="small"
                                                />
                                            </IconButton>
                                        </Tooltip>)}</>
                                ) : null}
                                {props.modPermission !=
                                    NO_ACCESS_PERMISSION &&
                                    props.showAgentRoomExport ? (
                                    <Tooltip
                                        title={props.customExportTitle ? props.customExportTitle : ""}
                                    >
                                        <IconButton
                                            color="primary"
                                            onClick={
                                                props.callAgentRoomExport
                                            }>
                                            <ExitToAppIcon
                                                fontSize="small"
                                                style={{
                                                    color: '#008000',
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {props.showApproveAndReject != undefined &&
                                    props.showApproveAndReject ? (
                                    <>
                                        {props.approveLoader ? (
                                            <IconButton title="Export Excel">
                                                <CircularProgress
                                                    size={20}
                                                />
                                            </IconButton>
                                        ) : (
                                            <Tooltip
                                                title="Approve"
                                                aria-label="Approve">
                                                <IconButton
                                                    color="primary"
                                                    onClick={() =>
                                                        props.multiApprove()
                                                    }
                                                    sx={{
                                                        cursor: 'pointer',
                                                    }}>
                                                    <Box
                                                        component="img"
                                                        className={
                                                            classes.actionIcon
                                                        }
                                                        alt="logo."
                                                        src={completedSvg}
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {props.rejectLoader ? (
                                            <IconButton title="Export Excel">
                                                <CircularProgress
                                                    size={20}
                                                />
                                            </IconButton>
                                        ) : (
                                            <Tooltip
                                                title="Reject"
                                                aria-label="Reject">
                                                <IconButton
                                                    color="primary"
                                                    onClick={() =>
                                                        props.multiReject()
                                                    }
                                                    sx={{
                                                        cursor: 'pointer',
                                                    }}>
                                                    <Box
                                                        component="img"
                                                        className={
                                                            classes.actionIcon
                                                        }
                                                        alt="logo."
                                                        src={rejectSvg}
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </>
                                ) : null}

                                {props.showExportDocuments != undefined &&
                                    props.showExportDocuments ?
                                    props.exportDocumentsLoader ? (
                                        <IconButton title="Export Credential Document">
                                            <CircularProgress
                                                size={20}
                                            />
                                        </IconButton>
                                    ) : (<Tooltip
                                        title="Export Image"
                                        aria-label="Export Image">
                                        <IconButton
                                            color="primary"
                                            onClick={() =>
                                                props.exportDocuments()
                                            }
                                            sx={{
                                                cursor: 'pointer',
                                            }}>
                                            <FilterIcon
                                                color="primary"
                                                fontSize="small"
                                            />
                                        </IconButton>
                                    </Tooltip>)
                                    : null}
                                {props.showSync != undefined ? (
                                    <Tooltip title="Refresh">
                                        <IconButton
                                            onClick={props.getResults}>
                                            <CachedIcon
                                                color="primary"
                                                fontSize="small"
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.syncParticipants != undefined ? (
                                    <Tooltip title="Sync Activity">
                                        <IconButton
                                            onClick={() =>
                                                props.syncParticipantsClick()
                                            }>
                                            <CachedIcon
                                                color="primary"
                                                fontSize="small"
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {/* {props.modPermission == FULL_PERMISSION &&
                                props.showPublish === true ? (
                                <Tooltip title={'UnPublish'}>
                                    <IconButton onClick={props.handleUnPublish}>
                                        <PublishOutlinedIcon
                                            fontSize="small"
                                            color={'primary'}
                                            sx={{ transform: 'rotate(180deg)' }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null}
                            {props.modPermission == FULL_PERMISSION &&
                                props.showPublish === true ? (
                                <Tooltip title={'Publish'}>
                                    <IconButton onClick={props.handlePublish}>
                                        <PublishOutlinedIcon
                                            fontSize="small"
                                            color={'primary'}
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null} */}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showColorPicker === true ? (
                                    <>
                                        <Button
                                            size="small"
                                            variant="contained"
                                            style={{
                                                backgroundColor:
                                                    props.primaryColor,
                                            }}
                                            onClick={() =>
                                                props.setShowPrimaryColorPicker(
                                                    () =>
                                                        !props.showPrimaryColorPicker
                                                )
                                            }>
                                            <ColorizeIcon />
                                        </Button>
                                        {props.showPrimaryColorPicker && (
                                            <ChromePicker
                                                color={props.primaryColor}
                                                onChange={(updatedColor) =>
                                                    props.setPrimaryColor(
                                                        updatedColor.hex
                                                    )
                                                }
                                            />
                                        )}
                                    </>
                                ) : null}
                                {/* {props.modPermission == FULL_PERMISSION &&
                                props.showPublish === true ? (
                                <Tooltip
                                    title={'Publish All'}
                                    onClick={() => props.publishAll()}>
                                    <IconButton
                                        disabled={
                                            props.data.length > 0 ? false : true
                                        }
                                        color="primary">
                                        <PublishOutlinedIcon
                                            sx={{
                                                m: 1,
                                            }}
                                            checked={props.publish}
                                            fontSize="small"
                                            color={'default'}
                                        // onChange={(
                                        //     e
                                        // ) =>
                                        //     props.onToggleChange(
                                        //         e
                                        //     )
                                        // }
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null}
                            {props.modPermission == FULL_PERMISSION &&
                                props.showUnPublish === true ? (
                                <Tooltip
                                    title={'UnPublish All'}
                                    onClick={() => props.unPublishAll()}>
                                    <IconButton
                                        disabled={
                                            props.data.length > 0 ? false : true
                                        }
                                        color="primary">
                                        <DownloadOutlinedIcon
                                            sx={{
                                                m: 1,
                                            }}
                                            checked={props.publish}
                                            fontSize="small"
                                            color={'default'} 
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null} */}

                                {props.modPermission == FULL_PERMISSION &&
                                    props.showPublish === true ? (
                                    <>
                                        {props.publishLoader ? (
                                            <IconButton title="Published">
                                                <CircularProgress
                                                    size={20}
                                                />
                                            </IconButton>
                                        ) : (<Tooltip
                                            title={'Publish Selected'}
                                            onClick={() =>
                                                props.publishSelected()
                                            }>
                                            <IconButton
                                                disabled={
                                                    props.data.length > 0
                                                        ? false
                                                        : true
                                                }
                                                color="primary">
                                                <PublishedWithChangesOutlinedIcon
                                                    fontSize="small"
                                                    color={'default'}
                                                    sx={{
                                                        m: 1,
                                                    }}
                                                    checked={props.publish}

                                                // onChange={(
                                                //     e
                                                // ) =>
                                                //     props.onToggleChange(
                                                //         e
                                                //     )
                                                // }
                                                />
                                            </IconButton>
                                        </Tooltip>)}
                                    </>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showPublish === true ? (
                                    <>
                                        {props.unpublishLoader ? (
                                            <IconButton title="Published">
                                                <CircularProgress
                                                    size={20}
                                                />
                                            </IconButton>
                                        ) : (<Tooltip
                                            title={'UnPublish selected'}
                                            onClick={() =>
                                                props.unPublishSelected()
                                            }>
                                            <IconButton
                                                color="primary"
                                                disabled={
                                                    props.data.length > 0
                                                        ? false
                                                        : true
                                                }>
                                                <UnpublishedOutlinedIcon
                                                    fontSize="small"
                                                    color={'default'}
                                                    sx={{
                                                        m: 1,
                                                    }}
                                                    checked={props.publish}

                                                // onChange={(
                                                //     e
                                                // ) =>
                                                //     props.onToggleChange(
                                                //         e
                                                //     )
                                                // }
                                                />
                                            </IconButton>
                                        </Tooltip>)}</>
                                ) : null}

                                {/* {props.modPermission == FULL_PERMISSION &&
                            props.showPublish === true ? (
                                <Tooltip
                                    title={'Publish'}
                                    onClick={() => props.onToggleChange()}>
                                    <IconButton
                                        disabled={
                                            props.data.length > 0 ? false : true
                                        }>
                                        <IOSSwitch
                                            sx={{
                                                m: 1,
                                            }}
                                            checked={props.publish}

                                            // onChange={(
                                            //     e
                                            // ) =>
                                            //     props.onToggleChange(
                                            //         e
                                            //     )
                                            // }
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null} */}
                                {props.modPermission !=
                                    NO_ACCESS_PERMISSION &&
                                    props.showToggleNotificaiton ? (
                                    <>
                                        <Tooltip
                                            title={'Notification ON'}
                                            onClick={(e) =>
                                                props.onNotificationChange(
                                                    e
                                                )
                                            }>
                                            <IconButton
                                                color="primary"
                                                onClick={
                                                    props.onNotificationChange
                                                }>
                                                <NotificationsActiveOutlinedIcon
                                                    fontSize="small"
                                                    style={{
                                                        color: 'default',
                                                    }}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip
                                            title={'Notification OFF'}
                                            onClick={(e) =>
                                                props.offNotificationChange(
                                                    e
                                                )
                                            }>
                                            <IconButton color="primary">
                                                <NotificationsOffOutlinedIcon
                                                    fontSize="small"
                                                    style={{
                                                        color: 'default',
                                                    }}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    </>
                                ) : null}
                                {Helper.isEventStaff(userInfo) &&
                                    props.modPermission !=
                                    NO_ACCESS_PERMISSION &&
                                    props.showStafftoggleChange ? (
                                    <Tooltip
                                        title={
                                            props.staffToggleChecked
                                                ? 'My Activity'
                                                : 'All Activity'
                                        }
                                        onClick={(e) =>
                                            props.onStaffToggleChange(e)
                                        }>
                                        <IconButton>
                                            <IOSNameSwitch
                                                sx={{
                                                    m: 1,
                                                }}
                                                checked={
                                                    props.staffToggleChecked
                                                }
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {props.modPermission !=
                                    NO_ACCESS_PERMISSION &&
                                    props.showExport != undefined ? (
                                    <Tooltip title={'Export Report'}>
                                        <span>
                                            {props.userActivityExcelLoader ? (
                                                <IconButton title="Export Excel">
                                                    <CircularProgress
                                                        sx={{
                                                            color: 'black',
                                                        }}
                                                        size={20}
                                                    />
                                                </IconButton>
                                            ) : (
                                                <IconButton
                                                    color="primary"
                                                    onClick={
                                                        props.showUserActivityExport
                                                            ? props.callUserActivityExport
                                                            : props.callExport
                                                    }>
                                                    <ExportExcelIcon
                                                        fontSize="small"
                                                        style={{
                                                            color: '#008000',
                                                        }}
                                                    />
                                                </IconButton>
                                            )}
                                        </span>
                                    </Tooltip>
                                ) : null}
                                {props.modPermission !=
                                    NO_ACCESS_PERMISSION &&
                                    props.showPdf ? (
                                    <Tooltip title={'Export PDF'}>
                                        <span>
                                            {props.userActivityExcelLoader ? (
                                                <IconButton title="Export PDF">
                                                    <CircularProgress
                                                        sx={{
                                                            color: 'black',
                                                        }}
                                                        size={20}
                                                    />
                                                </IconButton>
                                            ) : (
                                                <IconButton
                                                    color="primary"
                                                >
                                                    <PictureAsPdfOutlinedIcon
                                                        fontSize="small"
                                                        style={{
                                                            color: '#008000',
                                                        }}
                                                    />
                                                </IconButton>
                                            )}
                                        </span>
                                    </Tooltip>
                                ) : null}
                                {/* {props.modPermission == FULL_PERMISSION &&
                            props.showSettings != undefined ? (
                                <Tooltip
                                    title={'Settings'}
                                    onClick={props.onSettingClick}>
                                    <IconButton>
                                        <EditOutlinedIcon
                                            fontSize="small"
                                            color="primary"
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null} */}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showEditHotel ? (
                                    props.showHotelToggle ? (
                                        <Tooltip
                                            title="Edit"
                                            onClick={() =>
                                                props.handleEditAll()
                                            }
                                            aria-label="edit">
                                            <IconButton
                                                color="primary"
                                                disabled={
                                                    props.readOnlyOrHide ===
                                                        1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : false
                                                            : false
                                                        : false
                                                }>
                                                <EditOutlinedIcon
                                                    fontSize="small"
                                                    color={'default'}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    ) : (
                                        <>
                                            <Button
                                                sx={{ mx: 1 }}
                                                variant="contained"
                                                style={{ fontSize: 13 }}
                                                disabled={
                                                    props.readOnlyOrHide ===
                                                        1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : false
                                                            : false
                                                        : false
                                                }
                                                onClick={() =>
                                                    props.handleHotelSave()
                                                }>
                                                {props.saveHotelButtonTitle}
                                            </Button>
                                            <Button
                                                sx={{ mx: 1 }}
                                                variant="contained"
                                                style={{ fontSize: 13 }}
                                                disabled={
                                                    props.readOnlyOrHide ===
                                                        1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : false
                                                            : false
                                                        : false
                                                }
                                                onClick={() =>
                                                    props.handleEditAll()
                                                }>
                                                Cancel
                                            </Button>
                                        </>
                                    )
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showEdit &&
                                    !props.showEdittags ? (
                                    <Tooltip
                                        title="Edit"
                                        onClick={() => props.editAll()}
                                        aria-label="edit">
                                        <IconButton
                                            color="primary"
                                            disabled={
                                                props.readOnlyOrHide === 1
                                                    ? eventRole !==
                                                        AppConstants
                                                            .EVENT_ROLES[0]
                                                        ? userInfo.userType !==
                                                            AppConstants
                                                                .USER_TYPES[0]
                                                            ? true
                                                            : false
                                                        : false
                                                    : false
                                            }>
                                            <EditOutlinedIcon
                                                fontSize="small"
                                                color={'default'}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showEditroles ? (
                                    <Tooltip
                                        title="Edit Roles"
                                        onClick={() => props.EditallRoles()}
                                        aria-label="edit">
                                        <IconButton
                                            color="primary"
                                            disabled={
                                                props.readOnlyOrHide === 1
                                                    ? eventRole !==
                                                        AppConstants
                                                            .EVENT_ROLES[0]
                                                        ? userInfo.userType !==
                                                            AppConstants
                                                                .USER_TYPES[0]
                                                            ? true
                                                            : false
                                                        : false
                                                    : false
                                            }>
                                            <EditOffOutlinedIcon
                                                fontSize="small"
                                                color={'default'}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showEdittags ? (
                                    <Tooltip
                                        title="Edit Tags"
                                        onClick={() => props.EditallTages()}
                                        aria-label="edit">
                                        <IconButton
                                            color="primary"
                                            disabled={
                                                props.readOnlyOrHide === 1
                                                    ? eventRole !==
                                                        AppConstants
                                                            .EVENT_ROLES[0]
                                                        ? userInfo.userType !==
                                                            AppConstants
                                                                .USER_TYPES[0]
                                                            ? true
                                                            : false
                                                        : false
                                                    : false
                                            }>
                                            <EditOutlinedIcon
                                                fontSize="small"
                                                color={'default'}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showSendAll ? (
                                    <Box sx={{ marginRight: 2 }}>
                                        <LoadingButton
                                            variant="contained"
                                            style={{ fontSize: 13 }}
                                            onClick={props.handleSendEmail}
                                            loading={props.loading}>
                                            {props.sendAllbuttonTitle}
                                        </LoadingButton>
                                    </Box>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showUploadMassUpdateActivity ? (
                                    <>
                                        {props.uploadActivityLoader ? (
                                            <IconButton title="Send Schedule">
                                                <CircularProgress
                                                    size={20}
                                                />
                                            </IconButton>
                                        ) : (
                                            <Box>
                                                <label htmlFor="contained-button-file">
                                                    <Input
                                                        accept={
                                                            props.importFileType
                                                        }
                                                        id="contained-button-file"
                                                        type="file"
                                                        onChange={
                                                            props.handleMassUpdateImportActivity
                                                        }
                                                    />
                                                    <Tooltip
                                                        title="Upload Activity"
                                                        aria-label="upload">
                                                        <IconButton
                                                            variant="contained"
                                                            component="span"
                                                            color="primary">
                                                            <UploadFileOutlinedIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </label>
                                            </Box>)}</>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showUploadMassUpdateUser ? (
                                    <>
                                        {props.uploadUserLoader ? (
                                            <IconButton title="Send User">
                                                <CircularProgress
                                                    size={20}
                                                />
                                            </IconButton>
                                        ) : (
                                            <Box>
                                                <label htmlFor="contained-button-file">
                                                    <Input
                                                        accept={
                                                            props.importFileType
                                                        }
                                                        id="contained-button-file"
                                                        type="file"
                                                        onChange={
                                                            props.handleMassUpdateImportUser
                                                        }
                                                    />
                                                        <Tooltip
                                                            title="Upload User"
                                                            aria-label="upload">
                                                            {props.showToolBarButton ? (
                                                                <Button
                                                                variant="contained"
                                                                component="span"
                                                                color="primary">
                                                                <UploadFileOutlinedIcon color="white"/>
                                                                &nbsp;Upload User
                                                            </Button>
                                                            ) : (                                                                
                                                                <IconButton
                                                                    variant="contained"
                                                                    component="span"
                                                                    color="primary">
                                                                    <UploadFileOutlinedIcon />
                                                                </IconButton>
                                                            )}
                                                        </Tooltip>
                                                    {/* </Button> */}
                                                </label> 
                                            </Box>)}</>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.showUpdateTemplate && (
                                        <Tooltip
                                            title="Download Template"
                                            onClick={props.updateTemplate}
                                            aria-label="download">
                                            {props.showToolBarButton ? (<Button color="primary" variant="contained" sx={{ml:1}}>
                                                <FileDownloadOutlinedIcon
                                                    fontSize="small"
                                                    color={'default'}
                                                /> &nbsp;Download Template
                                            </Button>) : (
                                                <IconButton color="primary">
                                                    <FileDownloadOutlinedIcon
                                                        fontSize="small"
                                                        color={'default'}
                                                    />
                                                </IconButton>
                                            )}
                                        </Tooltip>
                                    )}

                                {props.modPermission == FULL_PERMISSION &&
                                    props.showTemplateDownload && (
                                        <Tooltip
                                            title="Download Template"
                                            onClick={props.downloadTemplate}
                                            aria-label="download">
                                            <IconButton color="primary">
                                                <FileDownloadOutlinedIcon
                                                    fontSize="small"
                                                    color={'default'}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                {props.showPdfExport && (
                                    <Box>
                                        <>
                                            {props.userActivityPDFLoader ? (
                                                <IconButton title="Export PDF">
                                                    <CircularProgress
                                                        sx={{
                                                            color: 'black',
                                                        }}
                                                        size={20}
                                                    />
                                                </IconButton>
                                            ) : (
                                                <Tooltip
                                                    title="Export PDF"
                                                    onClick={
                                                        props.callPdfExport
                                                    }
                                                    aria-label="pdf">
                                                    <IconButton color="primary">
                                                        <PictureAsPdfOutlinedIcon
                                                            fontSize="small"
                                                            color={
                                                                'default'
                                                            }
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </>
                                    </Box>
                                )}

                                {props.modPermission == FULL_PERMISSION &&
                                    props.import ? (
                                    <Box>
                                        <label htmlFor="contained-button-file">
                                            <Input
                                                accept={
                                                    props.importFileType
                                                }
                                                id="contained-button-file"
                                                type="file"
                                                onChange={
                                                    props.handleImportActivity
                                                }
                                            />
                                            <Tooltip
                                                title="Upload Activity"
                                                aria-label="upload">
                                                <IconButton
                                                    variant="contained"
                                                    component="span"
                                                    color="primary">
                                                    <UploadFileOutlinedIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </label>
                                    </Box>
                                ) : null}
                                {props.modPermission == FULL_PERMISSION &&
                                    props.invitationImport ? (
                                    <Box>
                                        <label htmlFor="contained-button-file">
                                            <Input
                                                accept={
                                                    props.importFileType
                                                }
                                                id="contained-button-file"
                                                type="file"
                                                onChange={
                                                    props.handleImportInvitation
                                                }
                                            />
                                            <Tooltip
                                                title="Upload Invitation"
                                                aria-label="upload">
                                                <IconButton
                                                    variant="contained"
                                                    component="span"
                                                    color="primary">
                                                    <UploadFileOutlinedIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </label>
                                    </Box>
                                ) : null}
                                {props.ShowOverallLocation !==
                                    undefined && (
                                        <Typography component="span">
                                            {eventInfo.location}
                                        </Typography>
                                    )}
                                {props.hideDelete !== undefined &&
                                    props.hideDelete ? null : props.modPermission ==
                                        FULL_PERMISSION ? (
                                    <Tooltip title="Delete">
                                        <IconButton
                                            onClick={() =>
                                                props.deleteRows()
                                            }
                                            disabled={
                                                props.readOnlyOrHide === 1
                                                    ? eventRole !==
                                                        AppConstants
                                                            .EVENT_ROLES[0]
                                                        ? userInfo.userType !==
                                                            AppConstants
                                                                .USER_TYPES[0]
                                                            ? true
                                                            : false
                                                        : false
                                                    : false
                                            }>
                                            <DeleteOutlineRoundedIcon
                                                fontSize="small"
                                                color={'default'}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                                {props.showArchive &&
                                    props.modPermission == FULL_PERMISSION ? (
                                    <Tooltip title="Archive">
                                        <span>
                                            <IconButton
                                                onClick={() =>
                                                    props.archiveAllRows()
                                                }
                                                disabled={
                                                    props.readOnlyOrHide ===
                                                        1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : false
                                                            : false
                                                        : false
                                                }>
                                                <ArchiveIcon
                                                    fontSize="small"
                                                    color={'primary'}
                                                />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                ) : null}
                                {props.showLocation !== undefined &&
                                    props.showLocation ? (
                                    // <Tooltip title="Add Location">
                                    //     <IconButton onClick={() => props.showLocationDiaglog()} >
                                    //         <AddLocationAltIcon
                                    //             fontSize="small"
                                    //             color={'primary'}
                                    //         />
                                    //     </IconButton>
                                    // </Tooltip>
                                    <Box sx={{ marginRight: '5px' }}>
                                        <Button
                                            variant="contained"
                                            style={{ fontSize: 13 }}
                                            startIcon={
                                                <AddLocationAltIcon color="white" />
                                            }
                                            onClick={() =>
                                                props.showLocationDiaglog()
                                            }>
                                            Overall location
                                        </Button>
                                    </Box>
                                ) : null}
                                {props.showSendInvite !== undefined &&
                                    props.showSendInvite ? (
                                    props.modPermission ==
                                        FULL_PERMISSION ? (
                                        <Box sx={{ marginRight: '5px' }}>
                                            <Button
                                                variant="contained"
                                                style={{ fontSize: 13 }}
                                                startIcon={
                                                    props.customLoaderForEmail ? (
                                                        <CircularProgressWithLabel
                                                            value={
                                                                props.progressValue
                                                            }
                                                        />
                                                    ) : (
                                                        <SendIcon color="white" />
                                                    )
                                                }
                                                onClick={() =>
                                                    props.inviteHandleClick()
                                                }>
                                                Send Invitation
                                            </Button>
                                        </Box>
                                    ) : null
                                ) : null}
                                {props.hideEdit ? null : (
                                    <Box>
                                        {props.hideAdd &&
                                            !props.showEdit &&
                                            props.modPermission &&
                                            props.modPermission ===
                                            FULL_PERMISSION &&
                                            !props.invitationPage ? (
                                            <Tooltip
                                                title="Edit"
                                                onClick={() =>
                                                    props.onSettingClick()
                                                }
                                                aria-label="edit">
                                                <IconButton
                                                    color="primary"
                                                    disabled={
                                                        props.readOnlyOrHide ===
                                                            1
                                                            ? eventRole !==
                                                                AppConstants
                                                                    .EVENT_ROLES[0]
                                                                ? userInfo.userType !==
                                                                    AppConstants
                                                                        .USER_TYPES[0]
                                                                    ? true
                                                                    : false
                                                                : false
                                                            : false
                                                    }>
                                                    <EditOutlinedIcon
                                                        fontSize="small"
                                                        color="#17408B"
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        ) : null}
                                    </Box>
                                )}
                                {!props.finalSubmit ? null : (
                                    <>
                                        {props.modPermission ==
                                            FULL_PERMISSION ? (
                                            <Button
                                                variant="contained"
                                                style={{ fontSize: 13, marginRight:'8px' }} 
                                                onClick={() =>
                                                    props.handleFinalSubmit()
                                                }
                                                disabled={props.disbaleFinalSubmit}
                                                >
                                                Submit
                                            </Button>
                                        ) : null}
                                    </>
                                )}
                                {props.hideAdd ? null : (
                                    <>
                                        {props.modPermission ==
                                            FULL_PERMISSION &&
                                            !props.showMenuAdd ? (
                                            <Button
                                                variant="contained"
                                                style={{ fontSize: 13 }}
                                                startIcon={
                                                    <AddIcon color="white" />
                                                }
                                                onClick={() =>
                                                    props.handleClick()
                                                }
                                                disabled={
                                                    props.disableAdd ||
                                                        props.readOnlyOrHide ===
                                                        1
                                                        ? eventRole !==
                                                            AppConstants
                                                                .EVENT_ROLES[0]
                                                            ? userInfo.userType !==
                                                                AppConstants
                                                                    .USER_TYPES[0]
                                                                ? true
                                                                : false
                                                            : false
                                                        : false
                                                }>
                                                {props.buttonTitle}
                                            </Button>
                                        ) : props.modPermission ==
                                            FULL_PERMISSION ? (
                                            <div>
                                                <Button
                                                    id="demo-customized-button"
                                                    aria-controls={
                                                        open
                                                            ? 'demo-customized-menu'
                                                            : undefined
                                                    }
                                                    aria-haspopup="true"
                                                    aria-expanded={
                                                        open
                                                            ? 'true'
                                                            : undefined
                                                    }
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={handleClick}
                                                    startIcon={
                                                        <AddIcon color="white" />
                                                    }>
                                                    {props.buttonTitle}
                                                </Button>
                                                <StyledMenu
                                                    id="demo-customized-menu"
                                                    MenuListProps={{
                                                        'aria-labelledby':
                                                            'demo-customized-button',
                                                    }}
                                                    anchorEl={anchorEl}
                                                    open={open}
                                                    onClose={handleClose}>
                                                    {props.toggleButtonList.map(
                                                        (item, index) => {
                                                            return (
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        item.onClick(
                                                                            item
                                                                        );
                                                                        handleClose();
                                                                    }}
                                                                    disableRipple
                                                                    key={
                                                                        index
                                                                    }>
                                                                    {item.icon ??
                                                                        ''}
                                                                    {
                                                                        item.title
                                                                    }
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                    {/* <MenuItem onClick={handleClose} disableRipple>
                                        <EditIcon />
                                        Edit
                                    </MenuItem>
                                    <MenuItem onClick={handleClose} disableRipple>
                                        <FileCopyIcon />
                                        Duplicate
                                    </MenuItem>
                                    <Divider sx={{ my: 0.5 }} />
                                    <MenuItem onClick={handleClose} disableRipple>
                                        <ArchiveIcon />
                                        Archive
                                    </MenuItem>
                                    <MenuItem onClick={handleClose} disableRipple>
                                        <MoreHorizIcon />
                                        More
                                        
                                    </MenuItem> */}
                                                </StyledMenu>
                                            </div>
                                        ) : null}
                                    </>
                                )}
                            </Box>
                        ) : null}
                    </Typography>
                    {props.showParticipantRoleTag ? (
                        <>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                {props.filterRoleNames &&
                                    props.filterRoleNames.length > 0 ? (
                                    <Box
                                        sx={{
                                            width: '100%',
                                            //flexBasis: '180px',
                                            flexGrow: 1,
                                            margin: '10px 0px 5px 10px',
                                            flexWrap: 'wrap',
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'left',
                                                alignItems: 'center',
                                                width: '100%',
                                                gap: '10px',
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={12}
                                                fontWeight={500}
                                                color="primary">
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems:
                                                            'center',
                                                    }}>
                                                    Roles{' '}
                                                    <span
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            backgroundColor:
                                                                '#DFE3EC',
                                                            color: '#394150',
                                                            borderRadius:
                                                                '50%',
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            height: '23px',
                                                            width: '23px',
                                                            marginLeft:
                                                                '5px',
                                                        }}>
                                                        {props.getrolesTotalCount()}
                                                    </span>{' '}
                                                    :
                                                </span>
                                            </Typography>
                                            {props.filterRoleNames &&
                                                props.filterRoleNames.length > 0
                                                ? props.filterRoleNames.map(
                                                    (data) => {
                                                        if (
                                                            data.roleName !==
                                                            null
                                                        ) {
                                                            return (
                                                                <Box
                                                                    onClick={() =>
                                                                        props.onParticipantTagClick(
                                                                            data
                                                                        )
                                                                    }
                                                                    sx={{
                                                                        display:
                                                                            'flex',
                                                                        flexDirection:
                                                                            'row',
                                                                        justifyContent:
                                                                            'left',
                                                                        alignItems:
                                                                            'center',
                                                                        backgroundColor:
                                                                            '#DFE3EC',
                                                                        borderRadius:
                                                                            '14px',
                                                                        cursor: 'pointer',
                                                                        //padding:'2px'
                                                                    }}>
                                                                    <Box
                                                                        sx={{
                                                                            color: '#394150',
                                                                            padding:
                                                                                '2px',
                                                                            fontSize: 12,
                                                                            fontWeight: 500,
                                                                            width: 'fit-content',
                                                                            backgroundColor:
                                                                                '#DFE3EC',
                                                                            borderRight:
                                                                                '3px solid lightgrey',
                                                                            borderRadius:
                                                                                '14px',
                                                                            padding:
                                                                                '0px 3px 0px 5px',
                                                                        }}>
                                                                        {
                                                                            data.roleName
                                                                        }
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            display:
                                                                                'flex',
                                                                            justifyContent:
                                                                                'center',
                                                                            alignItems:
                                                                                'center',
                                                                            backgroundColor:
                                                                                '#DFE3EC',
                                                                            color: '#394150',
                                                                            fontSize: 12,
                                                                            fontWeight: 500,
                                                                            height: '23px',
                                                                            width: '23px',
                                                                            borderRadius:
                                                                                '50%',
                                                                        }}>
                                                                        {
                                                                            data.times
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                            );
                                                        }
                                                    }
                                                )
                                                : null}
                                        </Box>
                                    </Box>
                                ) : null}
                                {!props.hideTagFilter && props.filterTagNames &&
                                    props.filterTagNames.length > 0 ? (
                                    <Box
                                        sx={{
                                            width: '100%',
                                            //flexBasis: '180px',
                                            flexGrow: 1,
                                            margin: '5px 0px 0px 10px',
                                            flexWrap: 'wrap',
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'left',
                                                alignItems: 'center',
                                                width: '100%',
                                                gap: '10px',
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={12}
                                                fontWeight={500}
                                                color="primary">
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems:
                                                            'center',
                                                    }}>
                                                    Tags{' '}
                                                    <span
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            backgroundColor:
                                                                '#DFE3EC',
                                                            color: '#394150',
                                                            borderRadius:
                                                                '50%',
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            height: '23px',
                                                            width: '23px',
                                                            marginLeft:
                                                                '5px',
                                                        }}>
                                                        {props.gettagTotalCount()}
                                                    </span>{' '}
                                                    :
                                                </span>
                                            </Typography>
                                            {props.filterTagNames &&
                                                props.filterTagNames.length > 0
                                                ? props.filterTagNames.map(
                                                    (data) => {
                                                        if (
                                                            data.tags !==
                                                            null
                                                        ) {
                                                            return (
                                                                <Box
                                                                    onClick={() =>
                                                                        props.onParticipantTagClick(
                                                                            data
                                                                        )
                                                                    }
                                                                    sx={{
                                                                        display:
                                                                            'flex',
                                                                        flexDirection:
                                                                            'row',
                                                                        justifyContent:
                                                                            'left',
                                                                        alignItems:
                                                                            'center',
                                                                        backgroundColor:
                                                                            '#DFE3EC',
                                                                        borderRadius:
                                                                            '14px',
                                                                        cursor: 'pointer',
                                                                        //padding:'2px'
                                                                    }}>
                                                                    <Box
                                                                        sx={{
                                                                            backgroundColor:
                                                                                '#DFE3EC',
                                                                            color: '#394150',
                                                                            padding:
                                                                                '2px',
                                                                            fontSize: 12,
                                                                            fontWeight: 500,
                                                                            width: 'fit-content',
                                                                            borderRadius:
                                                                                '14px',
                                                                            borderRight:
                                                                                '3px solid lightgrey',
                                                                            padding:
                                                                                '0px 3px 0px 5px',
                                                                        }}>
                                                                        {
                                                                            data.tags
                                                                        }
                                                                    </Box>
                                                                    <Box
                                                                        sx={{
                                                                            display:
                                                                                'flex',
                                                                            justifyContent:
                                                                                'center',
                                                                            alignItems:
                                                                                'center',
                                                                            backgroundColor:
                                                                                '#DFE3EC',
                                                                            color: '#394150',
                                                                            borderRadius:
                                                                                '50%',
                                                                            fontSize: 12,
                                                                            fontWeight: 500,
                                                                            height: '23px',
                                                                            width: '23px',
                                                                        }}>
                                                                        {
                                                                            data.times
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                            );
                                                        }
                                                    }
                                                )
                                                : null}
                                        </Box>
                                    </Box>
                                ) : null}
                            </Box>
                        </>
                    ) : null}
                </Toolbar>
                {
                    renderHotelAgentRequest()
                }
                {(props.endUserView) ?  props.moduleToShow === 'Credential' ?  
                        <CredentialAllotedUsedCount
                            moduleName={props.moduleDisplayName}
                            moduleToShow={props.moduleToShow}
                            eventConfig={props.eventConfig}
                            credentailDropdown={props.credentailDropdown}
                            dropdownUsedCount={props.dropdownUsedCount}
                        /> :
                      props.moduleToShow === 'DraftFlightInfo' || props.moduleToShow === 'GreenRoom' || props.moduleToShow === 'LunchRoom' ?
                        <AllotedUsedCount
                            moduleName={props.moduleDisplayName}
                            moduleToShow={props.moduleToShow}
                            eventConfig={props.eventConfig}
                        /> :
                        (props.moduleToShow === 'Hotel' || props.moduleToShow === 'Player Hotel' || props.moduleToShow === 'DraftHotel') ?
                            <>
                                {
                                    ((props.moduleToShow === 'Hotel' || props.moduleToShow === 'Player Hotel') ||
                                        (props.moduleToShow === 'DraftHotel' && props.eventConfigStatus
                                            && (props.eventConfigStatus.paid > 0 || props.eventConfigStatus.comp > 0))) ?

                                        <CompPurchaseCount eventConfigStatus={props.eventConfigStatus}
                                            compUsed={props.compUsed}
                                            purchaseUsed={props.purchaseUsed}
                                            moduleToShow={props.moduleToShow}
                                            showAgentRoomInfo={props.showAgentRoomInfo}
                                            isAgentRequestAccepted={(props.isAgentRequestAccepted === "" || props.isAgentRequestAccepted === undefined) ? true : props.isAgentRequestAccepted} />
                                        : null
                                }
                                <WaitListCount
                                    moduleToShow={props.moduleToShow}
                                    pendingWaitList={props.pendingWaitList ? parseInt(props.pendingWaitList) : 0}
                                    approvedWaitList={props.approvedWaitList ? parseInt(props.approvedWaitList) : 0} />

                            </> : null
                    : null
                }
            </Box>
            {' '}
        </>
    );
};

export default EnhancedTableToolbar;

EnhancedTableToolbar.defaultProps = {
    showArchive: false,
    invitationPage: false
}
